import { concat } from '../../helpers/common'
import { setLocalStorage } from '../../helpers/storage'
import { updateRouteParams } from '../../helpers/url'

import { ENABLED_NEW_THEME, SELECTED_PLATFORM, SELECTED_SELF_ACCOUNT } from '../reducers/app'
import { ROUTE_PARAMS } from '../../constants/routes'

const MODULE_NAME = 'APP/'

// PLOP_APPEND_PATTERN_ANCHOR_ACTION
export const GET_CURRENT_USER_PROFILE = concat(MODULE_NAME, 'GET_CURRENT_USER_PROFILE')
export const GET_CURRENT_USER_PROFILE_SUCCESS = concat(MODULE_NAME, 'GET_CURRENT_USER_PROFILE_SUCCESS')
export const GET_CURRENT_USER_PROFILE_FAILURE = concat(MODULE_NAME, 'GET_CURRENT_USER_PROFILE_FAILURE')

export const SUBMIT_SERVER_LOGOUT = concat(MODULE_NAME, 'SUBMIT_SERVER_LOGOUT')
export const SUBMIT_SERVER_LOGOUT_SUCCESS = concat(MODULE_NAME, 'SUBMIT_SERVER_LOGOUT_SUCCESS')
export const SUBMIT_SERVER_LOGOUT_FAILURE = concat(MODULE_NAME, 'SUBMIT_SERVER_LOGOUT_FAILURE')
export const CLEAR_SUBMIT_SERVER_LOGOUT = concat(MODULE_NAME, 'CLEAR_SUBMIT_SERVER_LOGOUT')

export const UPDATE_CURRENT_USER_PROFILE = concat(MODULE_NAME, 'UPDATE_CURRENT_USER_PROFILE')
export const UPDATE_CURRENT_USER_PROFILE_SUCCESS = concat(MODULE_NAME, 'UPDATE_CURRENT_USER_PROFILE_SUCCESS')
export const UPDATE_CURRENT_USER_PROFILE_FAILURE = concat(MODULE_NAME, 'UPDATE_CURRENT_USER_PROFILE_FAILURE')
export const CLEAR_UPDATE_CURRENT_USER_PROFILE = concat(MODULE_NAME, 'CLEAR_UPDATE_CURRENT_USER_PROFILE')

export const CREATE_CURRENT_USER_SELF_ACCOUNT = concat(MODULE_NAME, 'CREATE_CURRENT_USER_SELF_ACCOUNT')
export const UPDATE_CURRENT_USER_SELF_ACCOUNT = concat(MODULE_NAME, 'UPDATE_CURRENT_USER_SELF_ACCOUNT')

export const SET_USER_ACCOUNT_SETUP_MODE = concat(MODULE_NAME, 'SET_USER_ACCOUNT_SETUP_MODE')

export const SET_SELECTED_PLATFORM = concat(MODULE_NAME, 'SET_SELECTED_PLATFORM')

export const SET_SEARCH = concat(MODULE_NAME, 'SET_SEARCH')
export const CLEAR_SEARCH = concat(MODULE_NAME, 'CLEAR_SEARCH')

export const SET_SELECTED_SELF_ACCOUNT = concat(MODULE_NAME, 'SET_SELECTED_SELF_ACCOUNT')

export const GET_BANNERS = concat(MODULE_NAME, 'GET_BANNERS')
export const GET_BANNERS_SUCCESS = concat(MODULE_NAME, 'GET_BANNERS_SUCCESS')
export const GET_BANNERS_FAILURE = concat(MODULE_NAME, 'GET_BANNERS_FAILURE')

export const GET_ASYNC_SESSION = concat(MODULE_NAME, 'GET_ASYNC_SESSION')
export const GET_ASYNC_SESSION_SUCCESS = concat(MODULE_NAME, 'GET_ASYNC_SESSION_SUCCESS')
export const GET_ASYNC_SESSION_FAILURE = concat(MODULE_NAME, 'GET_ASYNC_SESSION_FAILURE')
export const CLEAR_ASYNC_SESSION = concat(MODULE_NAME, 'CLEAR_ASYNC_SESSION')

export const APPROVE_PLATFORM_CONNECTION = concat(MODULE_NAME, 'APPROVE_PLATFORM_CONNECTION')

export const SET_THEME_COLOR = concat(MODULE_NAME, 'SET_THEME_COLOR')
export const SET_THEME_WAS_PRESELECTED = concat(MODULE_NAME, 'SET_THEME_WAS_PRESELECTED')
export const SET_NEW_STYLES_THEME_ENABLED = concat(MODULE_NAME, 'SET_NEW_STYLES_THEME_ENABLED')

export const SET_PDF_GENERATION = concat(MODULE_NAME, 'SET_PDF_GENERATION')

// PLOP_APPEND_PATTERN_ANCHOR_ACTION_CREATOR
export function getCurrentUserProfile() {
  return { type: GET_CURRENT_USER_PROFILE }
}

export function getCurrentUserProfileSuccess(userData) {
  if (window.analytics) {
    // Segment analytics implementation
    window.analytics.identify(userData.id, {
      name: userData.full_name,
      email: userData.email
    })
  }
  return { type: GET_CURRENT_USER_PROFILE_SUCCESS, userData }
}

export function getCurrentUserProfileFailure(error) {
  return { type: GET_CURRENT_USER_PROFILE_FAILURE, error }
}

// Submit server logout
export function submitServerLogout(data) {
  return { type: SUBMIT_SERVER_LOGOUT, data }
}

export function submitServerLogoutSuccess(data) {
  return { type: SUBMIT_SERVER_LOGOUT_SUCCESS, data }
}

export function submitServerLogoutFailure(error) {
  return { type: SUBMIT_SERVER_LOGOUT_FAILURE, error }
}

export function clearSubmitServerLogout() {
  return { type: CLEAR_SUBMIT_SERVER_LOGOUT }
}

export function updateCurrentUserProfile(userId, userData) {
  return { type: UPDATE_CURRENT_USER_PROFILE, userId, userData }
}

export function updateCurrentUserProfileSuccess(userData) {
  return { type: UPDATE_CURRENT_USER_PROFILE_SUCCESS, userData }
}

export function updateCurrentUserProfileFailure(error) {
  return { type: UPDATE_CURRENT_USER_PROFILE_FAILURE, error }
}

export function clearUpdateCurrentUserProfile() {
  return { type: CLEAR_UPDATE_CURRENT_USER_PROFILE }
}

export function createCurrentUserSelfAccount(selfAccountData) {
  return { type: CREATE_CURRENT_USER_SELF_ACCOUNT, selfAccountData }
}

export function updateCurrentUserSelfAccount(selfAccountData) {
  return { type: UPDATE_CURRENT_USER_SELF_ACCOUNT, selfAccountData }
}

export function setUserAccountSetupMode(isSetupMode) {
  return { type: SET_USER_ACCOUNT_SETUP_MODE, isSetupMode }
}

export function setSearch(searchTerm, searchKey) {
  return { type: SET_SEARCH, searchTerm, searchKey }
}

export function clearSearch() {
  return { type: CLEAR_SEARCH }
}

export function setSelectedPlatform(platform) {
  setLocalStorage(SELECTED_PLATFORM, platform)
  // update current link on platform change - like on campaigns page
  updateRouteParams({
    [ROUTE_PARAMS.platform]: platform
  })
  return { type: SET_SELECTED_PLATFORM, platform }
}

export function setSelectedSelfAccount(accountId) {
  setLocalStorage(SELECTED_SELF_ACCOUNT, accountId)
  return { type: SET_SELECTED_SELF_ACCOUNT, accountId }
}

export function approvePlatformConnection(authData) {
  return { type: APPROVE_PLATFORM_CONNECTION, authData }
}

export function getBanners() {
  return { type: GET_BANNERS }
}

export function getBannersSuccess(bannersData) {
  return { type: GET_BANNERS_SUCCESS, bannersData }
}

export function getBannersFailure(error) {
  return { type: GET_BANNERS_FAILURE, error }
}

// get async sessions
export function getAsyncSession(sessionId, platform, params) {
  return { type: GET_ASYNC_SESSION, sessionId, platform, params }
}

export function getAsyncSessionSuccess(sessionData) {
  return { type: GET_ASYNC_SESSION_SUCCESS, sessionData }
}

export function getAsyncSessionFailure(error, sessionData = {}) {
  return { type: GET_ASYNC_SESSION_FAILURE, error, sessionData }
}

export function clearAsyncSession() {
  return { type: CLEAR_ASYNC_SESSION }
}

export function setThemeColor(themeColor) {
  return { type: SET_THEME_COLOR, themeColor }
}

export function setThemeWasPreselected() {
  return { type: SET_THEME_WAS_PRESELECTED }
}

export function setNewStylesThemeEnabled(isEnabled) {
  setLocalStorage(ENABLED_NEW_THEME, isEnabled)
  return { type: SET_NEW_STYLES_THEME_ENABLED, isEnabled }
}

export function setPdfGeneration(isGenerating) {
  return { type: SET_PDF_GENERATION, isGenerating }
}
